import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import ItemCardOther from "../../../../common/components/ItemCardOther";
import ItemListCardOther from "../../../../common/components/ItemListCardOther";
import { AuctionResponse } from "../../../types";

interface AuctionListViewProps {
    type: "list" | "grid",
    auctionList: AuctionResponse[],
    reloadPage: () => void,
}

const AuctionListViewOther = ({ type, auctionList, reloadPage }: AuctionListViewProps) => {
    const [itemList, setItemList] = useState<React.ReactNode[]>([]);

    useEffect(() => {
        let newList: React.ReactNode[] = [];
        for (let i = 0; i < auctionList.length; i++) {
            if (type === "grid") {
                newList.push(
                    <ItemCardOther item={auctionList[i]} reloadPage={reloadPage} />
                )
            } else if (type === "list") {
                newList.push(
                    <ItemListCardOther item={auctionList[i]} reloadPage={reloadPage} />
                )
            }
        }

        setItemList(newList);
    }, [type, auctionList])

    return (
        <div style={{ marginTop: 25 }}>
            <Row gutter={[10, 10]} align="middle" justify="center">
                {itemList.map((item, index) => {
                    return (
                        <Col
                            xl={type === "grid" ? 8 : 24}
                            xxl={type === "grid" ? 6 : 24}
                            key={index}
                            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            {item}
                        </Col>
                    )
                })}
            </Row>
        </div>
    )
}

export default AuctionListViewOther;